import * as z from 'zod';

import { booleanFormSchema, currencyInput, emailSchema, urlSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { partnerQuerySchema } from './partner-query-schema';

export const partnerFormSchema = partnerQuerySchema
  .pick({
    logo: true,
    icon: true,
    logo_light: true,
    id: true,
    // Termination & Notice Tracking
    termination_notice_date: true,
    required_notice_days: true,
    override_termination_date: true,
    termination_extension_days: true,
    calculated_termination_date: true,
    final_termination_date: true,
    // Tail Commission Settings
    tail_enabled: true,
    tail_percentage: true,
    tail_duration_months: true,
    tail_flat_monthly_payout: true,
    tail_start_month: true,
    // Transition Period Tail Settings
    transition_tail_enabled: true,
    transition_tail_percentage: true,
    transition_tail_duration_months: true,
    transition_tail_start_month: true,
  })
  .extend({
    name: z.string().min(3),
    website: urlSchema(),
    email: emailSchema(),
    status: statusFormSchema,
    code: z.string(),

    handle_invoicing: booleanFormSchema(),
    // Add validation for termination fields
    required_notice_days: z.number().min(0).nullable(),
    termination_extension_days: z.number().min(0).nullable(),
    tail_percentage: z.number().min(0).max(100).nullable(),
    tail_duration_months: z.number().min(0).nullable(),
    tail_flat_monthly_payout: currencyInput.formSchema(),
    transition_tail_percentage: z.number().min(0).max(100).nullable(),
    transition_tail_duration_months: z.number().min(0).nullable(),
  });

export type PartnerFormSchema = z.infer<typeof partnerFormSchema>;
